<!-- 企业详情 -->
<template>
  <div id='customerDetail'>
    <div class='headerRow' v-if='!searchOverallFlag'>
      <div class='headerLeft'>
        <pt-tag v-if="customerVO.relationsStr != '~'" :text='customerVO.relationsStr'></pt-tag>
        <pt-tag v-if="  customerVO.customerAttributes != null &&  customerVO.customerAttributes.attributeStart != '~' && customerVO.customerAttributes.attributeStart > 0 " :text="customerVO.customerAttributes.attributeStart + $t('aps.evaluate.form.star')"></pt-tag>
        <a-popover trigger='click' placement='bottomLeft' v-if='false'>
          <div slot='content'>
            <div style='min-width:300px;'>
              <a-steps direction='vertical' progressDot :current='0'>
                <a-step v-for='(item,index) in historyList' :key='index' v-if='item.status != 2'>
                  <div slot='title'>
                    <div v-if='item.status == 0' class='historyTitle'>
                      {{ $t('customer.customerDetail.checkingColumnA') }}
                    </div>
                    <div v-if='item.status == 1' class='historyTitle'>
                      <span v-if="item.cooperationGradeOldStr != '~'">{{ item.cooperationGradeOldStr }}</span>
                      <span v-if="item.cooperationGradeOldStr != '~'"
                            class='historyText'>{{ $t('customer.customerDetail.changeText') }}</span>
                      <span>{{ item.cooperationGradeStr }}</span>
                    </div>
                  </div>
                  <div slot='description'>
                    <div>
                      <div class='historyContent'>
                        <span>{{ item.createName }}</span>
                        <span class='historySmallText'>{{ $utils.format(item.createTime, 'YYYY-MM-DD') }}</span>
                        <span
                          v-text="item.cooperationGradeOldStr != '~' ? $t('customer.customerDetail.updateRelation') : $t('customer.customerDetail.createRelation')"></span>
                      </div>
                    </div>
                    <div v-if="item.cooperationGrade == 'Column_A' && item.status != 0 " class='historyContent'>
                      <span>{{ $t('customer.customerDetail.approveMan') }}</span>
                      <span class='historySmallText'>{{ item.approvalUserName }}</span>
                    </div>
                  </div>
                </a-step>
              </a-steps>
            </div>
          </div>
          <a-button type='link' ghost style='padding:0;'>
            <pt-icon type='icon-lishijiluomss1' class='historyIcon'></pt-icon>&nbsp;
          </a-button>
        </a-popover>
      </div>
      <div class='operation_div' v-if='isPersonl '>
        <a-button class='add_lease' @click='addMyCustomerEvent' v-if='customerVO.addFlag'>
          <pt-icon type='icon-shoucang'></pt-icon>
          {{ $t('customer.customerDetail.addMyCustomer') }}
        </a-button>
        <a-button v-show='false' class='add_lease' @click='changeModal.visible = true' v-if='customerVO.myCustomer'>
          <pt-icon type='icon-biangeng1'></pt-icon>
          {{ $t('customer.customerDetail.changeCustomerRelationship') }}
        </a-button>
        <a-button v-if='false' class='add_customerRemind' @click='showTips'>
          <pt-icon type='icon-tixing1'></pt-icon>
          {{ $t('deal.dealDetails.dealDetail.dateRemind') }}
        </a-button>

        <!-- 自定义属性 -->
        <a-button class='add_customerRecords'  @click='addCustomAttribute(null)' style="margin-right: 10px">
          <pt-icon type='icon-zidingyishuxing'></pt-icon>
          {{ $t('customer.customAttribute') }}
        </a-button>
        <!-- 提醒 -->
        <a-button class='add_customerRecords'  @click='addRemind(null)' style="margin-right: 10px">
          <pt-icon type='icon-tixing3'></pt-icon>
          {{ $t('customer.remind') }}
        </a-button>
        <a-button class='add_customerRecords'  @click='showCustomerRecord(null)' >
          <pt-icon type='icon-genjin1'></pt-icon>
          {{ $t('lease.follow') }}
        </a-button>
        <div class='function_buttons'>
          <a-popover trigger='click' v-model='functionButtonsVisible' placement='bottomRight'>
            <div slot='content' style='display:flex;flex-direction: column;' class='more-btn'>
              <template>
                <!-- 新增租约 -->
                <div class='btn' @click='showAddLease'>
                  <pt-icon type='icon-zengjia'></pt-icon>
                  {{ $t('lease.modal.title') }}
                </div>
                <!--                放入公池-->
                <div class='btn' @click='deleteCustomerEvent' v-if='customerVO.myCustomer'>
                  <pt-icon type='icon-biangeng'></pt-icon>
                  {{ $t('customer.customerDetail.deleteMyCustomer') }}
                </div>
                <!--                  <div class="btn" @click="deleteCustomerEvent" v-if="customerVO.myCustomer">-->
                <!--                    <pt-icon type="icon-biangeng"></pt-icon>-->
                <!--                    {{$t('customer.customerDetail.deleteMyCustomer')}}-->
                <!--                  </div>-->
                <div class='btn' @click='addTrackEvent' v-if='customerVO.myCustomer'>
                  <pt-icon type='icon-zhuanxuqiu'></pt-icon>
                  {{ $t('customer.customerDetail.toTrackList') }}
                </div>
                <div class='btn' @click='addDeal' v-if='customerVO.myCustomer'>
                  <pt-icon type='icon-zhuanjiaoyi1'></pt-icon>
                  {{ $t('customer.customerDetail.toDealList') }}
                </div>
              </template>
            </div>
            <a-button>
              {{ $t('deal.dealDetails.dealDetail.more') }}
              <a-icon type='caret-right' :rotate='-90' style='font-size:10px;' />
            </a-button>
          </a-popover>
        </div>


      </div>
      <div class='operation_div' v-show='hideEdit' v-else>
        <a-button class='add_lease' @click='addMyCustomerEvent' v-if='customerVO.addFlag'>
          <pt-icon type='icon-shoucang'></pt-icon>
          {{ $t('customer.customerDetail.addMyCustomer1') }}
        </a-button>
        <!--          <a-button class="add_lease" @click="changeModal.visible = true" v-if="customerVO.myCustomer">-->
        <!--            <pt-icon type="icon-biangeng1"></pt-icon>-->
        <!--            {{$t('customer.customerDetail.changeCustomerRelationship')}}-->
        <!--          </a-button>-->
        <!--          <a-button  class="add_customerRemind" @click="showTips" ><pt-icon type="icon-tixing1"></pt-icon>{{$t('deal.dealDetails.dealDetail.dateRemind')}}</a-button>-->
        <!-- 新增租约 -->
        <a-button class='add_lease' @click='showAddLease'>
          <pt-icon type='icon-zengjia'></pt-icon>
          {{ $t('lease.modal.title') }}
        </a-button>
        <a-button class='add_customerRecords1'  @click='showCustomerRecord(null)'>
          <pt-icon type='icon-genjin1'></pt-icon>
          {{ $t('lease.follow') }}
        </a-button>

        <!--          <div class="function_buttons">-->
        <!--            <a-popover trigger="click" placement="bottomRight">-->
        <!--              <div slot="content" style="display:flex;flex-direction: column;" class='more-btn' >-->
        <!--                <template >-->
        <!--                 -->
        <!--                  &lt;!&ndash;                放入公池&ndash;&gt;-->
        <!--                  <div class="btn" @click="deleteCustomerEvent" v-if="customerVO.myCustomer">-->
        <!--                    <pt-icon type="icon-biangeng"></pt-icon>-->
        <!--                    {{$t('customer.customerDetail.deleteMyCustomer')}}-->
        <!--                  </div>-->
        <!--&lt;!&ndash;                  <div class="btn" @click="deleteCustomerEvent" v-if="customerVO.myCustomer">&ndash;&gt;-->
        <!--&lt;!&ndash;                    <pt-icon type="icon-biangeng"></pt-icon>&ndash;&gt;-->
        <!--&lt;!&ndash;                    {{$t('customer.customerDetail.deleteMyCustomer')}}&ndash;&gt;-->
        <!--&lt;!&ndash;                  </div>&ndash;&gt;-->
        <!--                  <div class="btn" @click="addTrackEvent" v-if="customerVO.myCustomer">-->
        <!--                    <pt-icon type="icon-biangeng"></pt-icon>-->
        <!--                    {{$t('customer.customerDetail.toTrackList')}}-->
        <!--                  </div>-->
        <!--                  <div class="btn" @click="addDeal" v-if="customerVO.myCustomer">-->
        <!--                    <pt-icon type="icon-biangeng"></pt-icon>-->
        <!--                    {{$t('customer.customerDetail.toDealList')}}-->
        <!--                  </div>-->
        <!--                </template>-->
        <!--              </div>-->
        <!--              <a-button >-->
        <!--                {{$t('deal.dealDetails.dealDetail.more')}}-->
        <!--                <a-icon type="caret-right" :rotate="-90" style="font-size:10px;"/>-->
        <!--              </a-button>-->
        <!--            </a-popover>-->
        <!--          </div>-->


      </div>

    </div>
    <div class='content_div'>
      <div class='left_div'>
        <customer-info :is-customer='true' ref='customerInfoRef' :is-personl='isPersonl' :flash-relation='flashRelation' :customerVO='customerVO'
                       :canEditVisible='hideEdit' :hide-relation-visible='true'
                       @freshCompanyList='freshCompanyList' @freshCompanyDeatil='freshCompanyDeatil'></customer-info>
        <div class='mainDiv'>
          <div>
            <div class='titleRow' @click='showLeases = !showLeases'>
              <div class='circleYellow'></div>
              <!-- 关联租约 -->
              <div class='titleText'>{{ $t('customer.customerDetail.relatedLease1') }}</div>
              <div v-if='leaseList.length==0' class='number'>{{ $t('baseVO.empty') }}</div>
              <div class='right_icon' >
                <a-icon type='caret-up' v-show='showLeases' />
                <a-icon type='caret-down' v-show='!showLeases' />
              </div>
            </div>
            <div style='margin-bottom: 30px;' v-show='showLeases'>
              <pt-table :data-source='leaseList' :total='leaseList.length' :showSearch='false' :loading='false'>
                <template slot='columns'>
                  <el-table-column :label="$t('deal.addDeal.leaseContract.signTime')" show-overflow-tooltip>
                    <template slot-scope='scope'>
                      <template>
                        <span>{{ scope.row.signTime }}</span>
                      </template>
                    </template>
                  </el-table-column>
                  <el-table-column :label="$t('deal.addDeal.leaseContract.mansionName')" show-overflow-tooltip>
                    <template slot-scope='scope'>
                      <template>
                        <span>{{ scope.row.mansionName }}</span>
                      </template>
                    </template>
                  </el-table-column>
                  <el-table-column :label="$t('deal.addDeal.leaseContract.totalArea')" show-overflow-tooltip>
                    <template slot-scope='scope'>
                      <template>
                        <span>{{ scope.row.leaseArea }}{{ scope.row.areaUnitStr }}</span>
                      </template>
                    </template>
                  </el-table-column>
                  <el-table-column :label="$t('deal.addDeal.leaseContract.endTime')" show-overflow-tooltip>
                    <template slot-scope='scope'>
                      <template>
                        <span>{{ scope.row.endYearMoth }}</span>
                      </template>
                    </template>
                  </el-table-column>
                  <el-table-column :label="$t('deal.addDeal.leaseContract.rent')" show-overflow-tooltip>
                    <template slot-scope='scope'>
                      <template>
                        <span>{{ scope.row.rent }}{{ scope.row.rentUnitStr }}</span>
                      </template>
                    </template>
                  </el-table-column>
                  <el-table-column label='' align='center' width='60'>
                    <template slot-scope='scope'>
                      <pt-icon v-if="$route.path != '/manager/statistics/newMeeting'"
                               @click.native='showLeaseDetail(scope.row)' type='icon-xiangqingcopy' />
                    </template>
                  </el-table-column>
                </template>
              </pt-table>
              <!--                  <div>-->
              <!--                    <pt-tag style="cursor: pointer" v-for="(currentLeaseVO,index) in leaseList" :key="index"-->
              <!--                            @click.native="leaseChange(currentLeaseVO,index)" :color="leaseIndex == index ?'default':'grey'"-->
              <!--                            :text="$t('customer.customerDetail.lease') + (index + 1)" type="triangle" size="small"></pt-tag>-->
              <!--                  </div>-->
              <!--                  <deal-current-lease :defaultValue="currentLeaseVO" :show-edit-button="false"></deal-current-lease>-->

              <!--                <div v-else>-->
              <!--                  <pt-empty><span slot="description"></span></pt-empty>-->
              <!--                </div>-->
            </div>
          </div>
          <div>
            <div class='titleRow'  @click='showTrack = !showTrack'>
              <div class='circleYellow'></div>
              <div class='titleText'>{{ $t('customer.customerDetail.trackList') }}</div>
              <div v-if='pursuitsList.length==0' class='number'>{{ $t('baseVO.empty') }}</div>
              <div class='right_icon' v-if='showOperation' >
                <a-icon type='caret-up' v-show='showTrack' />
                <a-icon type='caret-down' v-show='!showTrack' />
              </div>
            </div>

            <div style='margin-bottom: 30px;' v-show='showTrack'>
              <pt-table :dataSource='pursuitsList' @tablePageChange='pursuitsTableChange' :total='pursuitsPage.total'
                        :showSearch='false' :loading='false'>
                <template slot='columns'>
                  <el-table-column :label="$t('customer.customerDetail.property')" class-name='type_icon' width='150'
                                   align='left' show-overflow-tooltip>
                    <template slot-scope='scope'>
                      <template v-if="scope.row.projectType != '~' && scope.row.type == 2">
                        <div class='icon_span'>
                          <div :style='selectIcon(scope.row.projectType).style'>
                            <pt-icon :type='selectIcon(scope.row.projectType).type' style='font-size: 20px;'></pt-icon>
                          </div>
                        </div>
                        <span>{{ $t('deal.dealTypes.' + scope.row.projectType) }}</span>
                      </template>
                      <template v-if="scope.row.projectType != '~' && scope.row.type == 1">
                        <template v-if="scope.row.projectType.split(',').length == 1">
                          <div class='icon_span'>
                            <div :style='selectIcon(scope.row.projectType).style'>
                              <pt-icon :type='selectIcon(scope.row.projectType).type'
                                       style='font-size: 20px;'></pt-icon>
                            </div>
                          </div>
                          <span>
                              {{ scope.row.projectType }}
                            </span>
                        </template>
                        <template v-else>
                          <div class='icon_span'>
                            <div style='background-color: rgb(227, 227, 227)'>
                              <pt-icon type='icon-duogeleixingtubiao-no'></pt-icon>
                            </div>
                          </div>
                          <span>
                              {{ scope.row.projectType }}
                            </span>
                        </template>
                      </template>
                    </template>
                  </el-table-column>
                  <el-table-column :label="$t('customer.customerDetail.startTime')" align='left' show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                      <a-tooltip >
                        <template #title>{{$t('customer.customerDetail.startTime')}}</template>
                        {{$t('customer.customerDetail.startTime')}}
                      </a-tooltip>
                    </template>
                    <template slot-scope='scope'>
                      {{ scope.row.expectStartDate }}
                    </template>
                  </el-table-column>
                  <el-table-column :label="$t('customer.customerDetail.needArea')" align='center'>
                    <template slot-scope='scope'>
                      <span>{{ scope.row.demandArea }}㎡</span>
                    </template>
                  </el-table-column>
                  <el-table-column :label="$t('customer.customerDetail.demandStatus')" show-overflow-tooltip
                                   align='center'>
                    <template slot-scope='scope'>
                      <span>{{getTrackDemandStatus(scope.row.demandStatus)}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column show-overflow-tooltip :label="$t('customer.customerList.latestTime')" align='center'>
                    <template slot="header" slot-scope="scope">
                      <a-tooltip >
                        <template #title>{{$t('customer.customerList.latestTime')}}</template>
                        {{$t('customer.customerList.latestTime')}}
                      </a-tooltip>
                    </template>
                    <template slot-scope='scope'>
                      <span>{{ scope.row.lastFollowDate | dayjs }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column :label="$t('customer.customerDetail.person')" align='center'>
                    <template slot-scope='scope'>
                      <avatar-list size='small' :max-length='2' :list-length='scope.row.employeeDOList.length'>
                        <avatar-list-item :tips='employeeDO.userName' v-for='employeeDO in scope.row.employeeDOList'
                                          :key='employeeDO.accountid'
                                          :src='getHelpsImg(employeeDO.headimg)' />
                      </avatar-list>
                    </template>
                  </el-table-column>
                  <el-table-column label='' align='center' width='60'>
                    <template slot-scope='scope'>
                      <pt-icon v-if="$route.path != '/manager/statistics/newMeeting'"
                               @click.native='showDetail(scope.row)' type='icon-xiangqingcopy' />
                    </template>
                  </el-table-column>
                </template>
              </pt-table>
            </div>
          </div>
          <div>
            <div class='titleRow'  @click='showDeal = !showDeal'>
              <div class='circleYellow'></div>
              <div class='titleText'>{{ $t('customer.customerDetail.dealList') }}</div>
              <div v-if='dealList.length==0' class='number'>{{ $t('baseVO.empty') }}</div>
              <div class='right_icon'>
                <a-icon type='caret-up' v-show='showDeal' />
                <a-icon type='caret-down' v-show='!showDeal' />
              </div>
            </div>
            <div style='margin-bottom: 30px;' v-show='showDeal'>
              <pt-table :dataSource='dealList' @tablePageChange='dealTableChange' :total='dealPage.total'
                        :showSearch='false' :loading='false'>
                <template slot='columns'>
                  <el-table-column :label="$t('customer.customerDetail.property')" class-name='type_icon' width='150'
                                   align='left' show-overflow-tooltip>
                    <template slot-scope='scope'>
                      <template v-if="scope.row.projectType != '~' && scope.row.type == 2">
                        <div class='icon_span'>
                          <div :style='selectIcon(scope.row.projectType).style'>
                            <pt-icon :type='selectIcon(scope.row.projectType).type' style='font-size: 20px;'></pt-icon>
                          </div>
                        </div>
                        <span>{{ $t('deal.dealTypes.' + scope.row.projectType) }}</span>
                      </template>
                      <template v-if="scope.row.projectType != '~' && scope.row.type == 1">
                        <template v-if="scope.row.projectType.split(',').length == 1">
                          <div class='icon_span'>
                            <div :style='selectIcon(scope.row.projectType).style'>
                              <pt-icon :type='selectIcon(scope.row.projectType).type'
                                       style='font-size: 20px;'></pt-icon>
                            </div>
                          </div>
                          <span>
                              {{ scope.row.projectType }}
                            </span>
                        </template>
                        <template v-else>
                          <div class='icon_span'>
                            <div style='background-color: rgb(227, 227, 227)'>
                              <pt-icon type='icon-duogeleixingtubiao-no'></pt-icon>
                            </div>
                          </div>
                          <span>
                              {{ scope.row.projectType }}
                            </span>
                        </template>
                      </template>
                    </template>
                  </el-table-column>
                  <el-table-column :label="$t('customer.customerDetail.needArea')" align='center'>
                    <template slot-scope='scope'>
                      <span>{{ scope.row.demandArea }}㎡</span>
                    </template>
                  </el-table-column>
                  <el-table-column :label="$t('deal.tableHeader.queryRow.projectStages1')" show-overflow-tooltip
                                   align='center'>
                    <template slot-scope='scope'>
                      <span>{{ scope.row.projectStagesStr }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column show-overflow-tooltip :label="$t('customer.customerList.latestTime')" align='center'>
                    <template slot="header" slot-scope="scope">
                      <a-tooltip >
                        <template #title>{{$t('customer.customerList.latestTime')}}</template>
                        {{$t('customer.customerList.latestTime')}}
                      </a-tooltip>
                    </template>
                    <template slot-scope='scope'>
                      <span>{{ scope.row.lastFollowDate | dayjs }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column :label="$t('customer.customerDetail.member')" align='center'>
                    <template slot-scope='scope'>
                      <avatar-list size='small' :max-length='4' :list-length='scope.row.employeeDOList.length'>
                        <avatar-list-item :tips='employeeDO.userName' v-for='employeeDO in scope.row.employeeDOList'
                                          :key='employeeDO.accountid'
                                          :src='getHelpsImg(employeeDO.headimg)' />
                      </avatar-list>
                    </template>
                  </el-table-column>
                  <el-table-column label='' align='center' width='60'>
                    <template slot-scope='scope'>
                      <pt-icon v-if="$route.path != '/manager/statistics/newMeeting'"
                               @click.native='showDetail(scope.row)' type='icon-xiangqingcopy' />
                    </template>
                  </el-table-column>
                </template>
              </pt-table>
            </div>
          </div>
          <div>
            <div class='titleRow'  @click='showNews = !showNews'>
              <div class='circleYellow'></div>
              <div class='titleText'>{{ $t('customer.customerDetail.customerNews') }}</div>
              <div v-if='newsSize == 0' class='number'>{{ $t('baseVO.empty') }}</div>

              <div class='right_icon'>
                <a-icon type='caret-up' v-show='showNews' />
                <a-icon type='caret-down' v-show='!showNews' />
              </div>
            </div>
            <div style='margin-bottom: 20px;' v-show='showNews'>
              <customer-news :customer-id='customerId' @newSize='getNewsSize'></customer-news>
            </div>
          </div>
          <div  v-action:CUSTOMERCONTROLLER_SHOWCUSTOMERCOST>
            <expense-cost :busienss-id='customerId' :business-type='2'></expense-cost>
          </div>
        </div>
      </div>
      <div class='right_div'>
        <div class='rightTitleRow'>
          <!-- 你的跟进 -->
          <div v-if='isPersonl' :class="tabActiveKey == 1 ? 'activeTitle':'defaultTitle'" @click='switchType(1)'>
            <div :title="$t('deal.dealDetails.dealDetail.yoursRecord')" class='titleFont'>{{ $t('deal.dealDetails.dealDetail.yoursRecord') }}</div>
            <div class='activeLine'></div>
          </div>
<!--          <div style='width: 1px;background: #F0F0F0;'></div>-->
          <!-- 所有跟进 -->
          <div :class="tabActiveKey == 2  ? 'activeTitle':'defaultTitle'" @click='switchType(2)'>
            <div  :title="$t('deal.dealDetails.dealDetail.allRecord')" class='titleFont'>{{ $t('deal.dealDetails.dealDetail.allRecord') }}</div>
            <div class='activeLine'></div>
          </div>
          <!-- 我的提醒 -->
          <div :class="tabActiveKey == 3  ? 'activeTitle':'defaultTitle'" @click='switchType(3)'>
            <div  :title="$t('customer.myRemind')" class='titleFont'>{{ $t('customer.myRemind') }}</div>
            <div class='activeLine'></div>
          </div>




          <!--            <a-tabs v-model:activeKey='tabActiveKey' @change='recordsChange'>-->
          <!--              <a-tab-pane  key="1"  :tab="$t('deal.dealDetails.dealDetail.yoursRecord')"/>-->
          <!--              <a-tab-pane key="2"  :tab="$t('deal.dealDetails.dealDetail.allRecord')" />-->
          <!--            </a-tabs>-->
          <!--            <div :class="tabActiveKey == 1 ? 'activeTitle':'defaultTitle'"  @click="switchType(1)">-->
          <!--              <div class="titleFont">{{$t('deal.dealDetails.dealDetail.followRecord')}}</div>-->
          <!--              <div class="activeLine"></div>-->
          <!--            </div>-->
          <!--            <div style="width: 1px;background: #F0F0F0;"></div>-->
          <!--            <div :class="tabActiveKey == 2  ? 'activeTitle':'defaultTitle'"  @click="switchType(2)">-->
          <!--              <div class="titleFont">{{$t('deal.dealDetails.dealDetail.reminderRecord')}}</div>-->
          <!--              <div class="activeLine"></div>-->
          <!--            </div>-->
        </div>
        <div class='lineBlock' style='height: 1px;background: #F0F0F0;'></div>
        <div v-if="tabActiveKey == 1 || tabActiveKey == 2" class='customer_records'>
          <!--            <div class="customer_records_title">{{$t('customer.customerDetail.followRecord')}}</div>-->
          <!--            <a-divider/>-->
          <customerRecordList  ref='customerRecordListRef' :business-type='1' :datadict-childs='datadictChilds' :show-edit-buttons='hideEdit'
                              :customer-records='customerRecords' @showCustomerRecord='showCustomerRecord'
                              :listPagination='listPagination'
          ></customerRecordList>
        </div>

        <div v-if="tabActiveKey == 3" class='customer_records'>
          <customerRemindList ref='customerRemindListRef' :remind-list='remindList'
                              :reminder-pagination='reminderPagination' @flushRemindList='flushRemindList' ></customerRemindList>
        </div>
      </div>
    </div>
    <customerRecord  :customer-company-id='customerVO.companyId'  :is-customer='true' :loading='customerRecordLoading' :visible='customerRecordVisible'
                    @hide='hideCustomerRecord' @saveSuccess='customerRecordSuccess' :customerId='customerVO.id'
                    :defaultValue='defaultCustomerRecord' ref='customerRecordRef'
                    :typeChangeVisible='true'></customerRecord>

    <pt-modal :title="$t('lease.modal.title')" :visible='modal.visible' :loading='modal.loading'
              @ok='submitEvent' @cancel='cancelEvent' :width='800'
    >
      <div slot='content'>
        <add-lease :defaultAreaUnit='defaultAreaUnit' :defaultRentUnit='defaultRentUnit' ref='addLeaseRef'
                   @saveSuccess='leaseSuccess' @error='errorEvent' :companyShow='false'
                   :customerVO='customerVO'></add-lease>
      </div>
    </pt-modal>
    <pt-modal :title="$t('track.trackModal.newTrackTitle')" :visible='trackModal.visible' :loading='trackModal.loading'
              @ok='submitTrack' @cancel='cancelTrack' :width='800'>
      <div slot='content'>
        <issue-track ref='issueTrackRef' :can-edit='false'  :customer-detail-v-o='customerVO' @saveSuccess='saveTrackSuccess'
                     @error='saveTrackError'></issue-track>
      </div>
    </pt-modal>
    <pt-modal :title="$t('deal.addDeal.addLeaseDeal')" :width='800' :visible='dealModal.visible' @cancel='cancelDeal'
              @ok='submit' :loading='dealModal.loading'>
      <div slot='content'>
        <addDeal ref='addDealRef' :customer-detail-v-o='customerVO' @saveSuccess='saveDealSuccess'
                 @validateFail='dealModal.loading = false'></addDeal>
      </div>
    </pt-modal>
    <pt-modal :title="$t('customer.customerDetail.changeCustomerRelations.title')" :visible='changeModal.visible'
              :loading='changeModal.loading'
              @ok='changeRelationEvent' @cancel='changeModal.visible = false' :width='800'>
      <div slot='content'>
        <change-relation ref='changeRelation' :customer='customerVO'></change-relation>
      </div>
    </pt-modal>

    <!-- 新增自定义属性 -->
    <pt-modal :title="$t('customer.customAttributeTitle')" :visible='attributeModal.visible'
              :loading='attributeModal.loading'
              @ok='changeAttribute' @cancel='attributeModal.visible = false' :width='550'>
      <div slot='content'>
        <customer-attribute ref='attributeRef' :customer-id='customerVO.id' ></customer-attribute>
      </div>
    </pt-modal>

    <!-- 新增提醒 -->
    <pt-modal :title="$t('customer.remind')" :visible='customerRemindModal.visible'
              :loading='customerRemindModal.loading'
              @ok='changeCustomerRemind' @cancel='customerRemindModal.visible = false' :width='550'>
      <div slot='content'>
        <add-customer-remind ref='customerRemindRef' :customer-id='customerVO.id' ></add-customer-remind>
      </div>
    </pt-modal>





    <addRemind :loading='tipLoading' :customer-v-o='customerVO' :visible='tipsVisible' @saveSuccess='tipsSaveSuccess'
               @hide='hideTips'></addRemind>

    <pt-drawer  :title="$t('customer.customerDetail.leaseTitle')"
               :visible="leaseDrawer.visible" :width="800" :z-index="999999" :show-footer="false" @close="leaseDrawer.visible=false">
      <div slot="content">
        <lease-detail :show-top-button='false'  :lease-id='leaseDrawer.id' ></lease-detail>
      </div>
    </pt-drawer>

    <pt-drawer  :title="dealPursuitsDrawer.type == 1?$t('customer.customerDetail.dealTitle'):$t('customer.customerDetail.pursuitsTitle1')"
               :visible="dealPursuitsDrawer.visible" :width="1150"  :z-index="999999" :show-footer="false"  @close="dealPursuitsDrawer.visible=false">
      <div slot="content">
        <dealDetail v-if="dealPursuitsDrawer.type == 1" :dealId="dealPursuitsDrawer.id" :showFunctionButton="false" :showEditButton="false"></dealDetail>
        <track-detail v-else :pursuitsId="dealPursuitsDrawer.id" :hideEdit="true"></track-detail>
      </div>
    </pt-drawer>

  </div>
</template>

<script>
import customerRecordList from '../../../mine/customer/customerRecordList'
import leaseApi from '@/api/database/lease'
import Api, { updateAttribute } from '@/api/mine/customer'
import AddCustomer from './addCustomer'
import customerRemindList from '@/views/mine/customer/customerRemindList.vue'
import addRemind from './addRemind'
import customerRecordsApi from '@/api/mine/customerRecords'
import customerRecord from '../../../mine/customer/editCustomerRecord'
import addLease from '../../lease/module/addLease'
import PtIcon from '../../../../components/Icon/index'
import ACol from 'ant-design-vue/es/grid/Col'
import ARow from 'ant-design-vue/es/grid/Row'
import dealApi, { queryDealPursuitsByCustomerIdAndType } from '@/api/mine/deal'
import apiCustomerAttribute from '@/api/mine/customerAttributes'
import AvatarList from '../../../../components/AvatarList/List'
import AvatarListItem from '../../../../components/AvatarList/Item'
import { getByCompanyIdAndType, unitTypeEnum } from '@/api/manager/unitUse'
import CustomerInfo from './customerInfo'
import { mapState } from 'vuex'
import customerNews from './customerNews'
import DealCurrentLease from '../../../mine/deal/dealCurrentLease'
import customerAttribute from './customerAttribute'
import changeRelation from './changeRelation'
import expenseCost from '@/views/mine/expense/expenseCost'
import issueTrack from '@/views/mine/pursuits/module/issueTrack'
import addCustomerRemind from '@/views/database/customer/module/addCustomerRemind.vue'
import addDeal from '@/views/mine/deal/addDeal'
import addTips from '@/views/mine/deal/addTips'
import { getDatadictChildsByPath } from '@/api/sys/datadict'
import unitApi from '@/api/manager/unit'
import LeaseDetail from '@/views/database/lease/module/leaseDetail'
import dealDetail from '../../../mine/deal/dealDetails'
import TrackDetail from '../../../mine/pursuits/module/trackDetail'
import reminderApi from '@/api/work/reminder'
export default {
  name: 'customerDetail',
  components: {
    DealCurrentLease,
    customerRecordList,
    CustomerInfo,
    customerAttribute,
    addCustomerRemind,
    customerRemindList,
    ARow,
    ACol,
    PtIcon,
    changeRelation,
    customerNews,
    expenseCost,
    issueTrack,
    addDeal,
    addRemind,
    AddCustomer, customerRecord, addLease, AvatarList, AvatarListItem,LeaseDetail,dealDetail,TrackDetail
  },
  props: {
    customerId: null,
    showOperation: {
      type: Boolean,
      default: true
    },
    searchOverallFlag: {
      type: Boolean,
      default: false
    },
    hideEdit: {
      type: Boolean,
      default: true
    },
    isPersonl: true,
  },
  data() {
    return {
      functionButtonsVisible: false,
      customerRecordLoading: false,
      historyList: [],
      remindList: [],
      currentLeaseVO: {},
      listPagination: {
        onChange: page => {
          this.listPagination.current = page
          this.selectCustomerRecords()
        },
        hideOnSinglePage: true,
        size: 'small',
        defaultPageSize: 5,
        pageSize: 5,
        current: 1,
        total: 0
      },
      flashRelation: false,
      trackModal: {
        visible: false,
        loading: false
      },
      dealModal: {
        visible: false,
        loading: false
      },
      dealPursuitsDrawer:{
        visible:false,
        type:1,
        id:null,
      },
      defaultAreaUnit: null,
      defaultRentUnit: null,
      modal: {
        visible: false,
        loading: false
      },
      changeModal: {
        visible: false,
        loading: false
      },
      attributeModal:{
        visible: false,
        loading: false
      },
      customerRemindModal:{
        visible: false,
        loading: false
      },
      leaseDrawer:{
        visible:false,
        id:null,
      },
      labelList: [1, 2, 3],
      contactList: [1, 2, 3],
      editMode: false,
      customerVO: {},//客户详情信息
      customerRecords: [],//客户跟进记录
      customerRecordVisible: false,
      defaultCustomerRecord: null,
      leaseList: [],//租约
      leaseIndex: 0,//第几份租约
      dealPage: {
        size: 10,
        current: 1,
        total: 0
      },//交易追踪列表分页
      pursuitsPage: {
        size: 10,
        current: 1,
        total: 0
      },//交易追踪列表分页
      reminderPagination: {
        onChange: page => {
          this.reminderPagination.current = page;
          this.initRemind()
        },
        hideOnSinglePage:true,
        showTotal:(total)=>{
          return `共${total}条`
        },
        current:1,
        size:'small',
        pageSize: 5,
        total:0,
      },
      pursuitsList: [],//追踪数据
      dealList: [],//交易数据
      showNews: false,
      showLeases: false,
      showDeal: false,
      showTrack: false,
      newsSize: 0,
      reminderDO: null,
      tipsVisible: false,
      tipLoading: false,
      tabActiveKey: '1',
      datadictChilds: [],
      userCompanyId:undefined,
    }
  },
  watch: {
  },
  computed: {
    ...mapState({
      accountId: state => state.user.accountId
    }),
    ...mapState({
      userInfo: state => state.user.info
    })
  },
  mounted() {
    this.init()
    this.$bus.$on('flushCustomerDetail', () => {
      this.queryCustomerDetail()
    })
  },
  methods: {
    initTabActiveKey(){
      if (this.isPersonl){

        this.tabActiveKey = 1
        console.log("tabActiveKey1",this.tabActiveKey)
      }else {

        this.tabActiveKey = 2
        console.log("tabActiveKey2",this.tabActiveKey)
      }
    },
    getTrackDemandStatus(value){
      var demandStatus = '~';
      var list =  this.$t('track.demandStatus')
      for (let i = 0; i < list.length; i++) {
        if (list[i].value == value){
          demandStatus =  list[i].name
        }
      }
      return demandStatus;
      console.log("list",list[1])
      console.log("value",value)
    },
    getRelationsSelects() {
      getDatadictChildsByPath('system.business_key.relation').then(res => {
        console.log('getRelationsSelects', res.data)
        this.datadictChilds = res.data

      })
    },
    switchType(type) {
      this.tabActiveKey = type
      if(type == 1 || type == 2){
        this.selectCustomerRecords()
      }else{
        this.initRemind()
      }

    },
    recordsChange() {
      this.selectCustomerRecords()
    },
    tipsSaveSuccess() {
      this.hideTips()
      this.init()
      this.$emit('freshCompanyList')
    },
    hideTips() {
      this.tipsVisible = false
      this.tipLoading = false
    },
    showTips() {
      this.reminderDO = null
      this.tipsVisible = true
    },
    addDeal() {
      this.functionButtonsVisible = false
      this.$refs.customerInfoRef.cancelEdit();
      let _this = this
      this.$ptConfirm({
        title: this.$t('customer.customerDetail.dealTips.title'),
        content: this.$t('customer.customerDetail.dealTips.content'),
        onOk() {
          _this.dealModal.visible = true
        },
        onCancel() {

        }
      })

    },
    saveDealSuccess() {
      this.cancelDeal()
      this.queryDealList()
      this.init()
      this.$emit('freshCompanyList')
    },
    cancelDeal() {
      this.dealModal.visible = false
      this.dealModal.loading = false
    },
    submit() {
      this.dealModal.loading = true
      this.$refs.addDealRef.submit()
      this.dealModal.loading = false
    },
    submitTrack() {
      if (!this.trackModal.loading) {
        this.trackModal.loading = true
        this.$refs.issueTrackRef.getData()
      }
    },
    clickEvent() {
      this.trackModal.visible = true
    },
    cancelTrack() {
      this.trackModal.visible = false
    },
    saveTrackError() {
      this.trackModal.loading = false
    },
    saveTrackSuccess() {
      this.trackModal.visible = false
      this.trackModal.loading = false
      this.queryPursuitsList()
      this.init()
      this.$emit('freshCompanyList')
    },
    getNewsSize(data) {
      console.log('---------', data)
      this.newsSize = data
    },

    freshCompanyList() {
      this.$emit('freshCompanyList')
      this.queryCustomerDetail()
    },
    selectIcon(dealType) {
      console.log('类型' + dealType)
      return this.$utils.getDealTypeIconNoBackground(dealType)
    },
    leaseChange(lease, index) {
      this.leaseIndex = index
      this.currentLeaseVO = lease
    },
    showCustomerRecord(value) {
      this.customerRecordVisible = true
      this.$refs.customerInfoRef.cancelEdit();
      if (value) {
        this.defaultCustomerRecord = value
        this.$nextTick(() => {
          this.$refs.customerRecordRef.initDefaultValue()
        })
      }
    },
    flushRemindList(){
      this.initRemind()
      this.$emit('freshCompanyList')
    },

    //新增自定义属性
    addCustomAttribute(){
      this.attributeModal.visible = true
    },

    //新增提醒
    addRemind(){
      this.customerRemindModal.visible = true
    },


    leaseSuccess() {
      this.cancelEvent()
      this.queryCustomerDetail()
      this.queryCustomerLeaseList()
      this.init()
      this.$emit('freshCompanyList')
    },
    submitEvent() {
      this.modal.loading = true
      this.$refs.addLeaseRef.submit()
    },
    cancelEvent() {
      this.modal.visible = false
      this.modal.loading = false
    },
    errorEvent() {
      this.modal.loading = false
    },
    hideCustomerRecord() {
      this.customerRecordVisible = false
      this.customerRecordLoading = false
      this.defaultCustomerRecord = null
    },
    freshCompanyDeatil() {
      this.$refs.customerRecordListRef.initCustomerRecordTypes()
      this.flashRelation = true
      this.$refs.customerInfoRef.flashRelationList();
      this.freshCompanyList()
      this.hideCustomerRecord()
      this.queryCustomerDetail()
      this.selectCustomerRecords()
      this.init()
      this.$emit('freshCompanyList')
    },
    customerRecordSuccess() {
      this.queryCustomerRelations()
      this.$refs.customerRecordListRef.initCustomerRecordTypes()
      this.flashRelation = true
      this.$refs.customerInfoRef.flashRelationList();
      this.freshCompanyList()
      this.hideCustomerRecord()
      this.queryCustomerDetail()
      this.selectCustomerRecords()
      this.init()
      this.$emit('freshCompanyList')
    },
    showAddLease() {
      this.functionButtonsVisible = false
      this.modal.visible = true
      this.$refs.customerInfoRef.cancelEdit();
    },
    selectCustomerRecords() {
      let this_ = this
      customerRecordsApi.selectByBusinessId(this_.customerId, 'customer', this.tabActiveKey, {
        size: this.listPagination.pageSize,
        current: this.listPagination.current
      }).then(res => {
        this_.customerRecords = res.data.records
        this_.listPagination.total = res.data.total
        console.log('customerRecords', res.data.records)
      })

    },
    getMansionUrl(fileId) {
      let url = this.$util.getFileUrl(fileId)
      return url
    },
    getHelpsImg(headimg) {
      let url = this.$util.getFileUrl(headimg)
      return url
    },
    getImageUrl() {
      let url = this.$util.getFileUrl(this.customerVO.logo)
      return url
    },
    getUserCompany(){
      this.userCompanyId=  this.userInfo.companyDO.companyId
      console.log('userCompanyId',this.userCompanyId)
    },
    init() {
      console.log('init')
      this.getUserCompany()
      this.initTabActiveKey()
      this.initRemind()
      this.getRelationsSelects()
      this.initDefaultAreaUnit()//查询租约默认单位
      this.initDefaultRentUnit()//查询租约默认单位
      this.queryCustomerDetail()
      this.queryCustomerRelations()
      this.selectCustomerRecords()//查询客户跟进记录
      this.queryCustomerLeaseList()//查询客户租约信息
      // this.queryDealPursuitsList();//查询交易追踪列表
      this.queryDealList()//查询交易列表
      this.queryPursuitsList()//查询追踪列表
    },
    initDefaultAreaUnit() {
      let p = new Promise((resolve, reject) => {
        getByCompanyIdAndType(unitTypeEnum.AREA).then(res => {
          if (res.code == 1) {
            this.defaultAreaUnit = res.data[0]
            resolve()
          } else {
            reject()
          }
        })
      })
      return p
    },
    initDefaultRentUnit() {
      let p = new Promise((resolve, reject) => {
        getByCompanyIdAndType(unitTypeEnum.RENT).then(res => {
          if (res.code == 1) {
            this.defaultRentUnit = res.data[0]
            resolve()
          } else {
            reject()
          }
        })
      })
      return p
    },
    queryCustomerLeaseList() {
      let this_ = this
      leaseApi.selectAllByCustomerId(this_.customerId).then(res => {
        if (res.code == 1) {
          console.log('queryCustomerLeaseList', res)
          this_.leaseList = res.data
          this_.leaseIndex = 0
          this_.currentLeaseVO = res.data[0]
        }
      })
    },
    dealTableChange(page, pageSize) {
      this.dealPage.current = page
      this.queryDealList()
    },
    pursuitsTableChange(page, pageSize) {
      this.pursuitsPage.current = page
      this.queryPursuitsList()
    },
    queryDealList() {
      console.log('queryDealList')
      let this_ = this
      dealApi.queryDealPursuitsByCustomerIdAndType({
        size: this_.dealPage.size,
        current: this_.dealPage.current
      }, this_.customerId, 1).then(res => {
        if (res.code == 1) {
          this_.dealList = res.data.records
          this_.dealPage.total = res.data.total
        }
      })
    },
    queryPursuitsList() {
      console.log('queryDealList')
      let this_ = this
      dealApi.queryDealPursuitsByCustomerIdAndType({
        size: this_.pursuitsPage.size,
        current: this_.pursuitsPage.current
      }, this_.customerId, 2).then(res => {
        if (res.code == 1) {
          this_.pursuitsList = res.data.records
          console.log("------this_.pursuitsList",this_.pursuitsList)
          this_.pursuitsPage.total = res.data.total
        }
      })
    },
    queryCustomerRelations() {
      let this_ = this
      Api.selectChangeInfo(this_.customerId).then(res => {
        if (res.code == 1) {
          this_.historyList = res.data
        }
      })
    },
    queryCustomerDetail() {
      let this_ = this
      Api.selectOne(this_.customerId).then(res => {
        if (res.code == 1) {
          this_.customerVO = res.data
          console.log('this_.customerVO', this_.customerVO)
        }
      })
    },

    editDetail() {
      this.editMode = true
    },
    cancelEdit() {
      this.editMode = false
    },
    saveEdit() {
      this.$refs.customerModel.submit()
    },
    showDetail(row) {
      console.log('-------', row)
      let result = false
      row.employeeDOList.forEach(data => {
        if (data.accountid == this.accountId) {
          result = true
        }
      })
      if (result) {
        //进入详情页
        console.log('進入詳情頁')
        this.dealPursuitsDrawer.type = row.type
        this.dealPursuitsDrawer.id = row.id
        // this.drawerInfo.visible = false
        this.dealPursuitsDrawer.visible = true
      } else {
        this.$message.warn(this.$t('baseVO.noAuthority'))
      }
    },
    //
    showLeaseDetail(row) {
      console.log('-------', row)
      let result = false
      //进入详情页
      console.log('進入租约詳情頁')
      // this.$emit('showLeaseDetail', row)

       console.log("--=-=-=-=-=-=")
        this.leaseDrawer.id = row.id
        this.leaseDrawer.visible = true

    },
    saveSuccess() {
      this.cancelEdit()
      this.queryCustomerDetail()
      this.$emit('freshCompanyList')
    },
    addMyCustomerEvent() {
      let _this = this
      this.$ptConfirm({
        title: this.$t('customer.customerDetail.addTips.title'),
        content: this.$t('customer.customerDetail.addTips.content'),
        onOk() {
          _this.execAddCustomer()
        },
        onCancel() {

        }
      })
    },
    execAddCustomer() {
      Api.addMyCustoner({ customerId: this.customerId }).then(res => {
        if (res.code == 1) {
          this.queryCustomerDetail()
          this.$refs.customerInfoRef.flashRelation = true
          this.$message.success(res.message)
          this.$emit('freshCompanyList')
        }
      })
    },
    addTrackEvent() {
      this.functionButtonsVisible = false
      this.$refs.customerInfoRef.cancelEdit();

      let _this = this
      this.$ptConfirm({
        title: this.$t('customer.customerDetail.addTrackTips.title'),
        content: this.$t('customer.customerDetail.addTrackTips.content'),
        onOk() {
          _this.trackModal.visible = true
        },
        onCancel() {

        }
      })
    },

    initRemind(){
      this.listLoading = true
      let reminderQueryVO = {
        size: this.reminderPagination.pageSize,
        current: this.reminderPagination.current,
        businessId:this.customerId,
        remindType:27
      }
      reminderApi.queryReminderListByBusinessId(reminderQueryVO).then(res=>{
        if(res.code == 1){
          this.remindList = res.data.records
          this.reminderPagination.total = res.data.total
        }
      })
    },


    deleteCustomerEvent() {
      this.functionButtonsVisible = false
      this.$refs.customerInfoRef.cancelEdit();
      let _this = this
      this.$ptConfirm({
        title: this.$t('customer.customerDetail.deleteTips.title'),
        content: this.$t('customer.customerDetail.deleteTips.content'),
        onOk() {
          _this.execDeleteCustomer()

        },
        onCancel() {

        }
      })
    },
    execDeleteCustomer() {
      Api.deleteCustomerAccount(this.customerId).then(res => {
        if (res.code == 1) {
          this.queryCustomerDetail()
          this.$message.success(res.message)
          this.$emit('freshCompanyList')
          this.$emit('close')
        }
      })
    },
    changeRelationEvent() {
      this.changeModal.loading = true
      this.$refs.changeRelation.submit().then(data => {
        data.customerId = this.customerId
        this.execChange(data)
      }).catch(() => {
        this.changeModal.loading = false
      })
    },

    changeAttribute(){
      let this_ = this
      this.attributeModal.loading = true
      this.$refs.attributeRef.getData().then(data => {
        console.log('changeAttribute1', data)
        console.log('changeAttribute2', this_.customerId)
        data.customerId = this.customerId
        this.execUpdateAttribute(data)
      }).catch(() => {
        this.attributeModal.loading = false
      })
    },

    execUpdateAttribute(data){
      if(data.id){
        apiCustomerAttribute.update(data).then(res => {
          if (res.code == 1) {
            this.$message.success(res.message)
            this.$emit('freshCompanyList')
            this.queryCustomerDetail()
            this.attributeModal.visible = false
          }
        }).finally(() => {
          this.attributeModal.loading = false
        })
      }else{
        apiCustomerAttribute.insert(data).then(res => {
          if (res.code == 1) {
            this.$message.success(res.message)
            this.$emit('freshCompanyList')
            this.queryCustomerDetail()
            this.attributeModal.visible = false
          }
        }).finally(() => {
          this.attributeModal.loading = false
        })
      }
    },

    changeCustomerRemind(){
      this.customerRemindModal.loading = true
      this.$refs.customerRemindRef.getData().then(data => {
        console.log('customerRemindRef:', data)
        this.execUpdateReminder(data)
      }).catch(() => {
        this.customerRemindModal.loading = false
      })
    },

    execUpdateReminder(data){
      reminderApi.insert(data).then(res=>{
        if(res.code == 1){
          this.$emit('freshCompanyList')
          this.initRemind()
          this.$message.success(res.message)
          this.customerRemindModal.visible = false
        }else{
          this.$message.error(res.message)
        }
      }).finally(()=>{
        this.customerRemindModal.loading = false
        }
      )


    },

    execChange(data) {
      Api.changeCustomerRelationship(data).then(res => {
        if (res.code == 1) {
          this.$message.success(res.message)
          this.changeModal.loading = false
          this.changeModal.visible = false
          this.queryCustomerDetail()
          this.queryCustomerRelations()
          this.$emit('freshCompanyList')
        }
      }).finally(() => {
        this.changeModal.loading = false
      })
    }
  }
}
</script>

<style scoped lang='less'>
.historyTitle {
  font-size: 14px;
  color: #4D4D4D;
  margin-bottom: 6px;
}

.historyText {
  font-size: 14px;
  color: #999999;
  margin: 0 6px;
}
.lineBlock{
  width: 80%;
  height: 1px;
  background: rgb(240, 240, 240);
  padding: 0 20px 0;
  margin: 20px 0;
  line-height: 1px;
  border-left: #ddd;
  border-right: #ddd;
  text-align: center;
  margin-left: auto;
  margin-right: auto;
}
.historyContent {
  font-size: 12px;
  color: #999999;
  margin-bottom: 4px;
}

.historySmallText {
  margin: 0 6px;
}

.number {
  margin-left: 10px;
  font-size: 14px;
  color: #999999;
  letter-spacing: 0;
  position: absolute;
  right: 40px;
}

.rightTitleRow {
  display: flex;
  flex-direction: row;

  .activeTitle {
    padding-top: 10px;
    //width: 50%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-left: 40px;
    align-items: center;
    cursor: pointer;
    align-self: flex-end;
    >div{
      text-align: center;
    }
    .titleFont {
      font-size: 14px;
      color: #000000;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      width: 80px;
    }

    .activeLine {
      margin-top: 12px;
      background: #FABE00;
      width: 50px;
      height: 4px;
    }
  }

  .defaultTitle {
    //width: 50%;
    padding-top: 10px;
    display: flex;
    margin-left: 40px;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    //background: #ffffff;
    cursor: pointer;
    align-self: flex-end;
    >div{
      text-align: center;
    }

    .titleFont {
      font-size: 14px;
      color: #999999;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      width: 80px;
    }

    .activeLine {
      margin-top: 12px;
      background: transparent;
      width: 50px;
      height: 4px;
    }
  }
}

#customerDetail {
  display: flex;
  flex-direction: column;

  .tagsRow {
    margin-left: 20px;
    margin-bottom: 5px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }

  .companyUrl {
    width: 200px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .icon_span {
    display: inline-block;
    margin-right: 5px;
    width: 35px;
    height: 35px;
    text-align: center;

    > div {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 35px;
      border-radius: 50%;
      height: 35px;
    }
  }

  .icon_span_1 {
    display: inline-block;
    height: 35px;
    line-height: 28px;
  }

  .info_lines {
    margin-bottom: 15px;
  }

  .title {
    font-size: 12px;
    color: #999999;
  }

  .content {
    font-size: 12px;
    color: #333333;
  }

  .headerRow {
    height: 50px;
    background: #FAFBFC;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    .headerLeft {
      display: flex;
      flex-direction: row;
      align-items: center;
    }

    .historyIcon {
      margin-left: 12px;
      color: #8D8D8D;
      font-size: 20px;
    }
  }

  .operation_div {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;

    .add_lease {
      margin-right: 15px;
    }

    .add_customerRemind {
      margin-right: 15px;
    }

    .add_customerRecords {
      //margin-right: 10px
    }

    .add_customerRecords1 {
      margin-right: 30px
    }

    .function_buttons {
      padding-right: 20px;

      .ant-btn {
        margin-left: 10px;
      }

    }
  }

  .more-btn {
    .btn {
      cursor: pointer;
      padding: 8px 0;

      .btn-icon {
        margin-right: 10px;
      }
    }
  }

  .content_div {
    display: flex;
    flex-direction: row;

    .left_div {
      padding: 10px;
      background: #FFF;
      flex: 1 0 650px;
      min-width: 650px;
      border-right: 1px solid #F0F0F0;

      .topRow {
        height: 50px;
        padding: 0 40px;
        display: flex;
        flex-direction: row-reverse;
        align-items: center;
      }

      .mainDiv {
        padding: 0 20px;
        margin-bottom: 60px;

        .infoRightDiv {
          display: flex;
          flex-direction: column;

          .nameRow {
            display: flex;
            flex-direction: row;
            margin-bottom: 10px;

            .companyText {
              font-size: 18px;
              color: #333333;
              margin-right: 12px;
            }
          }

          .companyInfoRow {
            display: flex;
            flex-direction: row;

            .labelText {
              margin-right: 10px;
            }
          }

          .customerLabelDiv {
            margin-top: 25px;
            margin-bottom: 20px;
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
          }

          .customerLabel {
            background: #FFFFFF;
            border: 1px solid #EAEAEA;
            border-radius: 4px;
            padding: 4px 8px;
            font-size: 12px;
            color: #333333;
            margin-right: 10px;
          }
        }

        .labelText {
          font-size: 12px;
          color: #999999;
        }

        .infoText {
          font-size: 12px;
          color: #333333;
        }

        .titleRow {
          background: #FAFBFC;
          height: 40px;
          display: flex;
          flex-direction: row;
          align-items: center;
          position: relative;
          margin-bottom: 5px;
          cursor: pointer;
          .circleYellow {
            width: 12px;
            height: 12px;
            background: #FABE00;
            border-radius: 50%;
            margin: 0 10px;
          }

          .titleText {
            font-size: 14px;
            color: #333333;
            font-weight: bold;
          }

          .right_icon {
            cursor: pointer;
            position: absolute;
            right: 10px;
            color: #CACACA;
            font-size: 12px;
            width: 30px;
            height: 40px;
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }

        .viewIconDiv {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 60px;
          margin-left: auto;

          .viewIcon {
            font-size: 16px;
          }
        }

        .contactRow {
          display: flex;
          flex-direction: row;
          border: 1px solid #EFF1F5;
          height: 50px;
          margin-bottom: 10px;

          .contactCol {
            display: flex;
            flex-direction: column;
            justify-content: center;
            padding-left: 20px;
          }

          .contactIconDiv {
            background: #FBFBFC;
            width: 60px;
            display: flex;
            justify-content: center;
            align-items: center;

            .contactIcon {
              font-size: 36px;
            }
          }
        }

        .customerRow {
          display: flex;
          flex-direction: row;
          align-items: center;
          padding: 4px 0;
          border-bottom: 1px solid #F7F9FC;

          .customerLogo {
            width: 40px;
            margin-right: 20px;
          }
        }

        .customerRow:last-child {
          border-bottom: 0px;
        }

        .columnDiv {
          display: flex;
          flex-direction: row;
          align-items: center;
        }
      }
    }

    .right_div {
      background: #FCFDFD;
      flex: 1 0 350px;
      max-width: 500px;

      .customer_records {
        padding: 0 20px;

        .customer_records_title {
          margin-top: 20px;
          font-size: 14px;
          color: #333333;
        }
      }
    }
  }

  /deep/ .el-table {
    .type_icon {
      /deep/ .cell {
        display: flex;
        align-items: center;

        > span {
          flex: auto;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
  }
}
</style>